// generated by srcset-codegen
import src from "./bullhorn.svg";

const width = 1209;
const height = 1020;
export default { src, width, height };
